<!--<div class="modal fade" id="updateUserModal" tabindex="-1" role="dialog" aria-labelledby="updateUserModalLabel" aria-hidden="true">-->
<!--  <div class="modal-dialog" role="document">-->
<!--    <div class="modal-content">-->
<!--      <div class="modal-header">-->
<!--        <h5 class="modal-title" id="updateUserModalLabel">Update User</h5>-->
<!--        <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
<!--          <span aria-hidden="true">&times;</span>-->
<!--        </button>-->

<!--      </div>-->
<!--      <form [formGroup]="form" (ngSubmit)="update()">-->
<!--        <div class="modal-body">-->
<!--&lt;!&ndash;          <div class="form-group">&ndash;&gt;-->
<!--&lt;!&ndash;            <label for="attribute1" class="col-form-label">Attribute 1:</label>&ndash;&gt;-->
<!--&lt;!&ndash;            <input type="text" class="form-control" id="attribute1" formControlName="attribute1">&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="form-group">&ndash;&gt;-->
<!--&lt;!&ndash;            <label for="attribute2" class="col-form-label">Attribute 2:</label>&ndash;&gt;-->
<!--&lt;!&ndash;            <input type="text" class="form-control" id="attribute2" formControlName="attribute2">&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--          &lt;!&ndash; Repeat the above block for more attributes &ndash;&gt;-->
<!--        </div>-->
<!--        <div class="modal-footer">-->
<!--          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>-->
<!--          <button type="submit" class="btn btn-primary">Save changes</button>-->
<!--        </div>-->
<!--      </form>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<div class="modal-header">
  <h5 class="modal-title">Update user attributes</h5>
  <button type="button" class="btn btn-link close pull-right" aria-label="Close" (click)="close()">
    <i class="fa fa-lg fa-times"></i>
  </button>
</div>
<div class="modal-body" [formGroup]="form">

  <div class="row mb-3 ps-5 pe-5" *ngFor="let a of enabledAttributes" formGroupName="attributes">
    <div class="col-1">
      <input class="form-check-input" #attributeCheck type="checkbox" [checked]="!!form.value.attributes[a]" (change)="toggleAttribute(a)" (click)="onCheckClick($event, attributeCheck.checked, a)">
    </div>
    <div class="col-8">{{a}}</div>
    <div class="col-15">
      <input type="text" class="form-control form-control-sm" id="a" formControlName="{{a}}" *ngIf="hasAttribute(a)">
    </div>
  </div>

<!--  <div class="row" *ngFor="let a of form.controls['attributes']['controls'] | keyvalue" formGroupName="attributes">-->
<!--    <div class="col-10">{{a.key}}</div>-->
<!--    <div class="col-14">-->
<!--      <input type="text" class="form-control" id="{{a.key}}" formControlName="{{a.key}}">-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="form-group" *ngFor="let a of form.controls['attributes']['controls'] | keyvalue" formGroupName="attributes">-->
<!--    <label for="{{a.key}}" class="col-form-label">{{a.key}}</label>-->
<!--    <input type="text" class="form-control" id="{{a.key}}" formControlName="{{a.key}}">-->
<!--  </div>-->
<!--  <div class="form-group">-->
<!--    <label for="attribute2" class="col-form-label">Attribute 2:</label>-->
<!--    <input type="text" class="form-control" id="attribute2" formControlName="attribute2">-->
<!--  </div>-->

</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="update()" [disabled]="form.invalid">
    <i class="fa fa-lg fa-plus-circle"></i>
    Submit
  </button>

  <button class="btn btn-outline-primary" (click)="close()">
    Close
  </button>
</div>

